export default __webpack_public_path__ + "static/media/logo.15d88dc0.svg";